import React from 'react'

export default class DeleteUserWidget extends React.Component {
  state = {
    disabled: true,
  }

  handleChange(event) {
    var username = localStorage.getItem('username')
    var userConfirm = event.target.value
    if (userConfirm === username) {
      this.setState({ disabled: false })
    } else {
      this.setState({ disabled: true })
    }
  }

  onClick(e) {
    e.preventDefault()
    this.props.deleteUser()
    this.setState({ disabled: true })
  }

  render() {
    return (
      <div className='form-group'>
        <label htmlFor='user-confirm' className='col-xs-12 col-sm-4 control-label'>Supprimer l'utilisateur :</label>
        <div className="col-xs-6 col-sm-4">
          <input type="text" ref='userConfirm' className="form-control" id='user-confirm' name='user-confirm' placeholder='Entrez votre login pour confirmer' onKeyUp={this.handleChange.bind(this)} />
        </div>
        <div className="col-xs-6 col-sm-2 pull-right">
          <button className="form-control button btn-danger" onClick={this.onClick.bind(this)} disabled={this.state.disabled}>
            { this.props.children ? this.props.children : 'Supprimer'}
          </button>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/DeleteUserWidget.js